<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <div class="content">
    <data-table #table (remove)="onDelete($event)" [columns]="columns" [dataProviderParams]="dataProviderParams" [searchAll]="true"
                    [dataProvider]="groupHasProfilesService">
    </data-table>

    <mat-form-field>
      <input #state="ngModel" (ngModelChange)="filterProfiles(currentSearchTerm)" [(ngModel)]="currentSearchTerm" [matAutocomplete]="tdAuto" matInput name="state"
             placeholder="Add Profile">
    </mat-form-field>

    <mat-autocomplete #tdAuto="matAutocomplete" (optionSelected)="addProfile($event)">
      <mat-option *ngFor="let profile of filteredProfiles" [disabled]="profileIdsInUse[profile.ProfileID]" [value]="profile.ProfileID">
        <span>
          {{ profile.firstName }}
          {{ profile.lastName }}
          <ng-container *ngIf="profile.nickName"> ({{profile.nickName}})</ng-container>
          <ng-container *ngIf="profile.email"> - {{profile.email}}</ng-container>
        </span>
      </mat-option>
    </mat-autocomplete>
  </div>
</page-content>
